"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_CONNECT_SIGNAL_ID = exports.NO_CONNECT_SIGNAL_NAME = void 0;
exports.isNoConnectSignal = isNoConnectSignal;
exports.buildNoConnectSignal = buildNoConnectSignal;
exports.readNoConnectPinsFromPayload = readNoConnectPinsFromPayload;
exports.readNoConnectFloatingBehaviorFromPayload = readNoConnectFloatingBehaviorFromPayload;
const CadstromUid_1 = require("../../../../../CadstromUid");
const generate_readable_id_1 = require("../../../../../GenerateReadableId/generate-readable-id");
const form_model_shape_1 = require("./form-model-shape");
exports.NO_CONNECT_SIGNAL_NAME = 'NC';
exports.NO_CONNECT_SIGNAL_ID = (0, generate_readable_id_1.generateReadableId)(CadstromUid_1.CadstromObjectType.Signal, exports.NO_CONNECT_SIGNAL_NAME, 0);
function isNoConnectSignal(signal) {
    return signal.attributes?.noConnect === true;
}
function buildNoConnectSignal(floatingBehavior) {
    return {
        id: exports.NO_CONNECT_SIGNAL_ID,
        name: exports.NO_CONNECT_SIGNAL_NAME,
        padRefs: [],
        pinRefs: [],
        attributes: { noConnect: true },
        ...(0, form_model_shape_1.floatingBehaviorField)(floatingBehavior),
    };
}
function readNoConnectPinsFromPayload(payload) {
    const ncSignal = payload.signals.find(isNoConnectSignal);
    if (ncSignal === undefined) {
        return [];
    }
    return [...(payload.pinout[String(ncSignal.id)] ?? [])];
}
function readNoConnectFloatingBehaviorFromPayload(payload) {
    return (0, form_model_shape_1.recoverFloatingBehaviorChoice)(undefined, payload.signals.find(isNoConnectSignal)?.floatingBehavior);
}
//# sourceMappingURL=no-connect-signal.js.map